/**
 * Configuration values for the Radioplayer Developer Hub
 */

// Determine environment - check if we're in production build
const isProduction = process.env.NODE_ENV === 'production' || process.env.GATSBY_ENV === 'production';

// API endpoints
const API = {
  // Contact form submission endpoint
  // For now, both environments use staging until production Lambda is deployed
  CONTACT_FORM: process.env.GATSBY_CONTACT_FORM_API || 
    (isProduction 
      ? 'https://hlitsqf3wi.execute-api.eu-west-1.amazonaws.com/production/contact'
      : 'https://5tq9o9ytob.execute-api.eu-west-1.amazonaws.com/staging/contact'),
};

export default {
  API,
  isProduction,
};
